import i18n from "../../language/i18n";

const SIMPLE_YES_NO = Object.freeze({
  YES: { value: true, text: i18n.t('Common.yes') },
  NO: { value: false, text: i18n.t('Common.no') },
});

export default SIMPLE_YES_NO;
